import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterStoreusers'
})
export class FilterStoreusersPipe implements PipeTransform {

  transform(items: any[], searchText: string): any[] {
    if(!items) return [];
    if(!searchText) return items;
    searchText = searchText.toLowerCase();
    return items.filter( it => {
    return it.user_name.toLowerCase().includes(searchText);
    });
   }


}
